import { useMutation } from "@tanstack/react-query";
import { useUserContext } from "../useUserContext";
import { reopenSupportTicket } from "@/app/_firebase/support";
import { SupportTicket } from "@/app/@types/support";
import { sendSupportEmail } from "./useSendSupportEmail";

const useReopenSupportTicket = () => {
  const user = useUserContext();

  return useMutation<void, Error, SupportTicket>({
    mutationFn: (ticket) =>
      reopenSupportTicket(user.uid, ticket, {
        uid: user.details?.uid ?? user.uid,
        fullName: user.details?.fullName ?? user.settings.name,
      }),
    onSuccess: (_data, ticket) => {
      if (ticket.unreadForTeam) return;
      sendSupportEmail({
        kind: "user_reply",
        ticket,
        replyBody: "(Ticket reopened)",
        replyAuthorName: user.details?.fullName ?? user.settings.name,
      });
    },
  });
};

export default useReopenSupportTicket;
